module.exports = __webpack_public_path__ + "img/icon_5_38.4027d1ef.png";